/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Te_Effect_OverreachingInputs */

const en_ui_te_effect_overreaching = /** @type {(inputs: Ui_Te_Effect_OverreachingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overreaching`)
};

const de_ui_te_effect_overreaching = /** @type {(inputs: Ui_Te_Effect_OverreachingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Überbelastung`)
};

/**
* | output |
* | --- |
* | "Overreaching" |
*
* @param {Ui_Te_Effect_OverreachingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_te_effect_overreaching = /** @type {((inputs?: Ui_Te_Effect_OverreachingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Te_Effect_OverreachingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_te_effect_overreaching(inputs)
	return de_ui_te_effect_overreaching(inputs)
});